import { render, staticRenderFns } from "./HomeCommunity.vue?vue&type=template&id=c6a2d6ec&"
import script from "./HomeCommunity.vue?vue&type=script&lang=js&"
export * from "./HomeCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports